export default "__VITE_ASSET__32cfc382__"